import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Transaction, TransRow } from 'gossamer-model';
import {
  Display,
  IsAllowed,
  List,
  NavIconContainer,
  PageTitle,
  QueryMulti,
  QuerySingle,
  Section,
} from 'gossamer-front-end';
import { getSimpleCondition } from 'gossamer-unified';

export const TransactionDisplay: React.FC = () => {
  const params = useParams();
  const keyValue = params.key;
  if (!keyValue) {
    return <></>;
  }
  return (
    <>
      <NavIconContainer entityId={Transaction.id} />
      <PageTitle verb="Display" entity={Transaction} keyValue={keyValue} subtitle="An update" />
      <Section>
        <QuerySingle entity={Transaction} keyValue={keyValue} render={Display} />
      </Section>

      <IsAllowed entity={TransRow} action="read">
        <Section title="Record Changes" subtitle="Records created, updated or deleted in this Transaction">
          <QueryMulti
            entity={TransRow}
            alterEntity={(localEntity: typeof TransRow) => {
              localEntity.fields.trans_id.listColumn = false;
            }}
            queryOptions={{
              where: getSimpleCondition('trans_id', keyValue),
            }}
            render={List}
          />
        </Section>
      </IsAllowed>
    </>
  );
};
